export default [
    {
        path: 'dispensacao-materiais',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-dispensacao-materiais' */
            '@/views/almoxarifado/dispensacao-materiais/Index'
        ),
        redirect: 'dispensacao-materiais/index',
        children: [
            {
                name: 'almoxarifado-dispensacao-materiais-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-dispensacao-materiais' */
                    '@/views/almoxarifado/dispensacao-materiais/List.vue'
                ),
            },
            {
                name: 'almoxarifado-dispensacao-materiais-create',
                path: 'create/:pacienteId',
                props: route => ({ pacienteId: parseInt(route.params.pacienteId) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-dispensacao-materiais' */
                    '@/views/almoxarifado/dispensacao-materiais/Form.vue'
                ),
            },
            {
                name: 'almoxarifado-dispensacao-materiais-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-dispensacao-materiais' */
                    '@/views/almoxarifado/dispensacao-materiais/Form.vue'
                ),
            },
        ],
    },
]